import type { ResourceContainerResourceContainer as ResourceContainerResourceContainerModel } from '@/adapters/catalogv1.g';

export function extractResourceContainerResourceContainer(
  model: ResourceContainerResourceContainerModel
) {
  return {
    id: model._metadata?.distinct_id ?? '',
    parentContainerRef: model.parent_container_ref ?? '',
    childContainerRef: model.child_container_ref ?? '',
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogResourceContainerResourceContainer = ReturnType<
  typeof extractResourceContainerResourceContainer
>;
